import { http } from '../../../utils';
const controller = 'master-data/business-process-catalogs';
export const getBusinessProcessCatalogs = async (page, pageSize, orderBy, searchCondition, departmentId, status) => {
    return await http.get(controller, {
        params: {
            departmentId,
            searchCondition,
            status,
            page,
            pageSize,
            orderBy
        }
    });
};
export const getBusinessProcessCatalog = async (id) => {
    return http.get(`${controller}/${id}`);
};
export const addBusinessProcessCatalog = async (BusinessProcessCatalog) => {
    return http.post(controller, BusinessProcessCatalog);
};
export const updateBusinessProcessCatalog = async (id, BusinessProcessCatalog) => {
    return await http.put(`${controller}/${id}`, BusinessProcessCatalog);
};
export const deleteBusinessProcessCatalog = async (id) => {
    return await http.delete(`${controller}/${id}`);
};
export const getBusinessProcessCatalogsDropdown = async () => {
    return await http.get(`${controller}/dropdown`);
};
